export const OtrosTramites = ({color, clase}) => {
    return (
        <svg 
            width="24" 
            height="30" 
            viewBox="0 0 24 30" 
            fill="none" 
            mlns="http://www.w3.org/2000/svg"
            className={clase}
            >
            <rect x="1.5" y="1.5" width="21" height="27" rx="2.5" stroke={color} strokeWidth="3"/>
            <line x1="5.5" y1="13.5" x2="18.5" y2="13.5" stroke={color} strokeWidth="3" strokeLinecap="round"/>
            <line x1="5.5" y1="18.5" x2="18.5" y2="18.5" stroke={color} strokeWidth="3" strokeLinecap="round"/>
            <line x1="5.5" y1="23.5" x2="12.5" y2="23.5" stroke={color} strokeWidth="3" strokeLinecap="round"/>
            <line x1="5.5" y1="7.5" x2="9.5" y2="7.5" stroke={color} strokeWidth="3" strokeLinecap="round"/>
            <line x1="7.5" y1="5.5" x2="7.5" y2="9.5" stroke={color} strokeWidth="3" strokeLinecap="round"/>
       
        </svg>

    )
}